export default __webpack_public_path__ + "static/media/mode-40.81fc5fdc.svg";